import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, EffectFade } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

import styles from "./index.module.scss";

export interface CarouselProps {
  /** Contenuto degli slide (ogni child = uno slide) */
  children: React.ReactNode[];
  /** Numero di slide visibili (default 1) */
  slidesPerView?: number | "auto";
  /** Spazio tra gli slide in px (default 0) */
  spaceBetween?: number;
  /** Loop infinito (default false) */
  loop?: boolean;
  /** Effetto di transizione: 'slide' | 'fade' | 'cube' | 'coverflow' | 'flip' | 'cards' (default 'slide') */
  effect?: "slide" | "fade" | "cube" | "coverflow" | "flip" | "cards" | "creative";
  /** Mostra pagination dots (default true) */
  pagination?: boolean;
  /** Mostra frecce di navigazione (default false) */
  navigation?: boolean;
  /** Consenti swipe/drag (default true) */
  allowTouchMove?: boolean;
  /** Callback quando cambia slide */
  onSlideChange?: (swiper: SwiperType) => void;
  /** Classe aggiuntiva per il wrapper */
  className?: string;
}

const Carousel: React.FC<CarouselProps> = ({
  children,
  loop = false,
  effect = 'slide',
  slidesPerView = 1,
  spaceBetween = 0,
  pagination = true,
  navigation = false,
  allowTouchMove = true,
  onSlideChange,
  className,
}) => {
  const slides = Array.isArray(children) ? children : [children];

  const modules = [Pagination, Navigation, ...(effect === "slide" ? [EffectFade] : [])];

  return (
    <div className={`${styles.carousel} ${className ?? ""}`.trim()}>
      <Swiper
        modules={modules}
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        allowTouchMove={allowTouchMove}
        loop={loop}
        effect={effect}
        pagination={pagination ? { clickable: true } : false}
        navigation={navigation}
        onSlideChange={onSlideChange ?? (() => {})}
        className={styles.swiper}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index} className={styles.slide}>
            {slide}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Carousel;
